<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "DataListSingle" });
import { InputRadio } from "../index.js";
import { onDestroy, onMount, createEventDispatcher } from "svelte";
export let key;
export let query = void 0;
export let showList;
export let blacklist = [];
export let options = [];
export let name;
let listComponentWrapper = null;
let limit = 20;
const ADDED_ITEMS_ON_SCROLL = 10;
const isQueryInLabel = (label, query2) => label?.toLowerCase().includes((query2 ?? "").toLowerCase());
const isQueryInExternalRefKey = (externalReferenceKey, query2) => (
// eslint-disable-next-line implicit-arrow-linebreak
(externalReferenceKey ?? "").toLowerCase().includes((query2 ?? "").toLowerCase()));
const isQueryMatch = ({ label, externalReferenceKey }, query2) => query2 === "" || isQueryInLabel(label, query2) || isQueryInExternalRefKey(externalReferenceKey, query2);
const isDisabled = (option) => blacklist.includes(option.key);
const isAlmostScrolledToBottom = (element) => {
    return element.scrollTop + element.clientHeight >= element.scrollHeight - 10;
};
$: visibleOptions = options.filter((option) => isQueryMatch(option, query)).slice(0, limit);
const onScroll = () => {
    if (listComponentWrapper && isAlmostScrolledToBottom(listComponentWrapper)) {
        limit += ADDED_ITEMS_ON_SCROLL;
    }
};
const handleDocumentClick = ({ target }) => {
    if (listComponentWrapper === null) {
        return;
    }
    if (target === null) {
        return;
    }
    if (listComponentWrapper.contains(target)) {
        return;
    }
    showList = false;
    query = void 0;
};
onMount(() => {
    document.addEventListener("click", handleDocumentClick, true);
    listComponentWrapper?.addEventListener("scroll", onScroll);
});
onDestroy(() => {
    document.removeEventListener("click", handleDocumentClick, true);
    listComponentWrapper?.removeEventListener("scroll", onScroll);
});
export const onEnterClicked = () => {
    const OPTIONS = options.filter((option) => isQueryMatch(option, query));
    if (OPTIONS.length === 1) {
        const [FIRST_OPTION] = OPTIONS;
        ({ key } = FIRST_OPTION);
        showList = false;
    }
};
const dispatch = createEventDispatcher();
const matches = (query2) => {
    if (query2 === void 0) {
        return;
    }
    if (visibleOptions.length > 0) {
        dispatch("hasMatches");
    }
    if (visibleOptions.length === 0) {
        dispatch("noMatches");
    }
};
$: matches(query);
</script>

<div
    class = 's8-datalist-single'
    class:s8-visible = { showList === true || query !== undefined }
    bind:this = { listComponentWrapper }
>
    <ul>
        {#if visibleOptions.length === 0}
            <li>No options available</li>
        {/if}
        {#each visibleOptions as option}
            {#if isQueryMatch(option, query)}
                <li>
                    <InputRadio
                        bind:key = { key }
                        value = { option.key }
                        isDisabled = { isDisabled(option) }
                        label = { option.label }
                        name = { `${ name }_${ option.key }` }
                        style = 'datalist'
                    />
                </li>
            {/if}
        {/each}
    </ul>
</div>

<style>
    div.s8-datalist-single {
        position: absolute;
        top: 40px;
        left: 0px;
        right: 0px;
        padding: 0px;
        overflow-x: hidden;
        border-radius: 10px;
        box-shadow: 0 1px 3px 0px rgba(39,39,17,0.24);
        background-color: #fff;


        transition: margin 200ms ease-in-out,
            max-height 200ms ease-in-out,
            opacity 200ms ease-in-out;
    }

        div.s8-datalist-single.s8-visible {
            opacity: 1;
            max-height: 200px;
            overflow-y: scroll;
            margin-top: -10px;
            z-index: 20;
            padding: 10px;
        }

        div.s8-datalist-single:not(.s8-visible) {
            opacity: 0;
            max-height: 0;
            overflow-y: hidden;
            margin-top: 0px;
            z-index: 0;
        }</style>